import React, { Component } from 'react'
class Footer extends Component {
    render() {
  
        return (
            <div style={{width: '100%',paddingRight: '50px', marginTop: '5px'}}>
              <img width={20} src="https://tradexsafely.com/web/assets/img/Icon.png" style={{marginRight:'10px', float: 'right', marginRight: '10px'}} />
              <div style={{textAlign:'center',padding: '5px', color: 'green', float: 'right', marginRight: '10px'}}>
                Secured by tradexsafely &#169; 
              </div>
            </div>
        )
      }
  
}
export default  Footer;
